// extracted by mini-css-extract-plugin
module.exports = {"termsCheckbox":"paymentMethod_termsCheckbox__5NI2A","focus-visible":"paymentMethod_focus-visible__Teuoe"};